import React from "react";

const AIInsights = () => {
  return (
    <div className="p-8 text-white">
      <h1 className="text-3xl font-bold mb-4">🧠 AI Insights</h1>
      <p>This page will provide AI-driven analytics for inventory trends and forecasting.</p>
    </div>
  );
};

export default AIInsights;
